import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, onQuote }) {
  return (
    <article
      data-testid={`product-card-${product.id}`}
      className="group relative flex flex-col bg-brand-surface border border-brand-line hover:border-brand-moss/60 transition-all duration-500"
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-brand-surfaceAlt">
        <img
          src={product.image_url}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 bg-brand-surface/90 backdrop-blur-sm text-[11px] tracking-[0.2em] uppercase px-3 py-1 text-brand-moss">
          {product.category}
        </span>
      </div>
      <div className="p-6 flex flex-col flex-1 gap-3">
        <h3 className="font-serif text-2xl text-brand-ink leading-snug">{product.name}</h3>
        {product.inci_name && (
          <p className="text-xs italic text-brand-muted">INCI · {product.inci_name}</p>
        )}
        <p className="text-sm text-brand-muted leading-relaxed line-clamp-3">{product.description}</p>
        <div className="flex flex-wrap gap-2 mt-1">
          {product.applications.slice(0, 3).map((a) => (
            <span
              key={a}
              className="text-[11px] uppercase tracking-wider px-2.5 py-1 bg-brand-surfaceAlt text-brand-ink/80"
            >
              {a}
            </span>
          ))}
        </div>
        <div className="mt-auto pt-5 flex items-center justify-end border-t border-brand-line">
          <button
            onClick={() => onQuote(product)}
            className="inline-flex items-center gap-1.5 text-sm text-brand-terracotta hover:text-brand-terracottaDark transition-colors font-medium"
            data-testid={`quote-btn-${product.id}`}
          >
            Request Quote <ArrowUpRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </article>
  );
}
